import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, cap = 50, enabled = true): string {
    if (enabled && value && value.length > cap) {
      const truncated = `${value.substring(0, cap)} (...)`;
      return value.endsWith('.') ? `${truncated}.` : truncated;
    }
    return value;
  }
}
